import Button from '@mui/material/Button';
import * as React from 'react';
import Shop from '../shop';
import If from './If';
import { ShopContext } from './ShopProvider';

interface AddToCartProps {
  id: string;
  pid: string;
  availableForSale: boolean;
  width?: string;
  name: string;
  isLegacy: boolean;
}
export default function ButtonAddToCart(props: AddToCartProps) {
  const [message, setMessage] = React.useState('ADD TO CART');
  const [oos, setOos] = React.useState('Preorder for the next batch!');
  const shop = React.useContext(ShopContext) as Shop;
  const [available, setAvailable] = React.useState(props.availableForSale);

  React.useEffect(() => {
    const update = async () => {
      setAvailable(
        await shop.isVariantAvailable(
          props.pid,
          props.id,
          props.availableForSale
        )
      );
    };
    update();
  });

  const reverb =
    'https://reverb.com/marketplace?query=' +
    props.name +
    '&product_type=keyboards-and-synths&category=eurorack&make=noise-engineering';

  return (
    <>
      <If value={available}>
        <Button
          color='primary'
          style={{
            borderRadius: '0px',
            alignItems: 'center',
            justifyContent: 'center',
            whiteSpace: 'normal',
            wordBreak: 'normal',
            display: 'flex',
            fontFamily: 'OCR A Std',
            fontSize: '1rem',
            width: '98%',
          }}
          variant='contained'
          sx={{ mr: 2, mb: 2, mt: 2 }}
          onClick={async (e: any) => {
            e.stopPropagation();
            setMessage('ADDING');
            try {
              await shop.addItemToCart(props.id);
              setMessage('ADDED');
            } catch (e: any) {
              setMessage('ERROR');
              console.log(e);
            }
          }}
        >
          {message}
        </Button>
      </If>

      <If value={!available}>
        <If value={!props.isLegacy}>
          {' '}
          <Button
            color='info'
            style={{
              borderRadius: '0px',
              alignItems: 'center',
              justifyContent: 'center',
              whiteSpace: 'normal',
              wordBreak: 'break-all',
              display: 'flex',
              fontFamily: 'OCR A Std',
              fontSize: '1rem',
              width: '98%',
              cursor: 'not-allowed',
            }}
            variant='contained'
            sx={{ mr: 2, mb: 2 }}
          >
            Sold Out, More Coming Soon!
          </Button>
        </If>{' '}
        <If value={props.isLegacy}>
          {' '}
          <a href={reverb} target='_blank'>
            <Button
              color='info'
              style={{
                borderRadius: '0px',
                alignItems: 'center',
                justifyContent: 'center',
                whiteSpace: 'normal',
                wordBreak: 'break-all',
                display: 'flex',
                fontFamily: 'OCR A Std',
                fontSize: '1rem',
                width: '98%',
              }}
              variant='contained'
              sx={{ mr: 2, mb: 2, contrastText: 'error' }}
            >
              <>Search Reverb.com</>
            </Button>
          </a>
        </If>
      </If>
    </>
  );
}
